import React from 'react';
import styles from './ErrorFallback.module.css';
import errorImg from '../../assets/error.svg';
import { getTranslation } from '../../util/utilFunc';
import { useSelector } from 'react-redux';


export default function ErrorFallback({ error, resetErrorBoundary }) {
  const { language } = useSelector((state) => state.auth);

  return (
    <div className={styles.errorContainer}>
      <div>
        <img src={errorImg} alt="error" />
      </div>

      <div className={styles.btn__wrapper}>
        <button onClick={resetErrorBoundary} className="primaryBtn">
          {getTranslation("Try Again", language)}
        </button>
        <a href="/" className="outlinedBtn">
          {getTranslation("Go to Home!", language)}
        </a>
      </div>
      <p>{error?.message}</p>

    </div>
  );
}